import * as actions from '@/modules/rescueCodes'

export const fetchRescueCode = async ({ dispatch, rootGetters }, code) => {

  if (rootGetters['fetching/isFetching'](code)) {
    return await rootGetters['fetching/getRequest'](code);
  }

  const request = actions.fetchRescueCode(code);

  const response = await dispatch('fetching/doRequest', { id: code, request }, { root: true })

  dispatch('upsertRescueCode', response.data)

  return response;
}

export const requestRefund = async ({ dispatch }, params) => {
  const { code, ...body } = params;

  const response = await actions.requestRefund(code, body);

  dispatch('upsertRescueCode', response.data)

  return response;
}

export const upsertRescueCode = async ({ commit, dispatch }, data) => {

  const { experienceVariation, ...rescueCode } = data;

  if (experienceVariation) {
    dispatch('experiences/upsertExperience', experienceVariation, { root: true })
  }

  commit('upsertOne', rescueCode)
}

export default {
  fetchRescueCode,
  requestRefund,
  upsertRescueCode
}
